<template>
    <table v-if="zendeskInfo.userInfo.devOpsUrl=='https://moorepayhr.visualstudio.com'">
        <tr>
            <th class="no-wrap">Deployment:</th>
            <td>
                <template v-if="linkedWorkItem['Custom.DeploymentDate']">&nbsp;{{linkedWorkItem['Custom.DeploymentDate']|formatDate}}</template>
                <template v-else>&nbsp;NA</template>
            </td>
        </tr>
    </table>
</template>
<style scoped>
    
</style>
<script>
import Vue from "vue";
import CommonFactory from '@/mixins/common.factory';
export default Vue.extend({
    mixins: [CommonFactory],
    name: 'customIndexRenderer',
    props: {
        linkedWorkItem: {
            type: Object,
            required: true   // ✅ makes the prop required
        },
        zendeskInfo: {
            type: Object,
            required: true   // ✅ makes the prop required
        }
    },
    data() {
        return {
            type:'',
            val:null,
            item:null
        }
    },
    created(){
        let _self = this;
        
    },
    methods: {
        
    }
});
</script>
